module.exports = __webpack_public_path__ + "img/12.1572a356.png";